import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

export function useDriveBrowse(path = "") {
  return useQuery({
    queryKey: ["drive-browse", path],
    queryFn: async () => (await apiClient.get("/drive/browse", { params: { path } })).data,
  });
}
